<!--  -->
<template>
  <div class="wechat_boxr">
    <div class="select_box">
      <div class="oneselect_box">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          :picker-options="pickerOptions"
          :clearable="false"
        />
      </div>
      <div>
        <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" @click="onReset">重置</el-button> -->
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column prop="page_path" label="页面路径" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.page_path }}
          <span v-if="scope.row.page_path == 'pages/index/index'">（首页）</span>
          <span v-if="scope.row.page_path == 'pages/customerservice/customerservice'">（客服页面）</span>
          <span v-if="scope.row.page_path == 'pages/classification/classification'">（分类页面）</span>
          <span v-if="scope.row.page_path == 'pages/bookInfo/bookInfo'">（书籍详情）</span>
          <span v-if="scope.row.page_path == 'pages/my/my'">（我的页面）</span>
          <span v-if="scope.row.page_path == 'pages/signin/signin'">（签到页面）</span>
          <span v-if="scope.row.page_path == 'pages/remen/remen'">（热门页面）</span>
          <span v-if="scope.row.page_path == 'pages/fenlei/fenlei'">（分类页面）</span>
          <span v-if="scope.row.page_path == 'pages/info/info'">（详情页面）</span>
          <span v-if="scope.row.page_path == 'pages/search/search'">（搜索页面）</span>
        </template>
      </el-table-column>
      <el-table-column prop="page_visit_pv" label="访问次数(PV)" align="center" />
      <el-table-column prop="page_visit_uv" label="访问人数(UV)" align="center" />
      <el-table-column prop="page_staytime_pv" label="次均停留时长" align="center" />
      <el-table-column prop="entrypage_pv" label="进入页次数" align="center" />
      <el-table-column prop="exitpage_pv" label="退出页次数" align="center" />
      <el-table-column prop="page_share_pv" label="转发次数" align="center" />
      <el-table-column prop="page_share_uv" label="转发人数" align="center" />
    </el-table>

    <el-tag v-if="!is_show" type="warning" style="margin-left: 20px;margin-top: 20px;">链接点击总数：{{ click_count }}</el-tag>
    <el-table
      v-if="!is_show"
      :data="newtablredata"
      border
      stripe
      style="width: 100%;margin-top: 20px;"
    >
      <el-table-column prop="title" label="标题" align="center" />
      <el-table-column prop="iqiyi_promotion_link_no" label="编号" align="center" />
      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.app_id }}（{{ scope.row.account_name }}）
        </template>
      </el-table-column>
      <el-table-column prop="click_date_text" label="统计时间" align="center" />
      <el-table-column prop="click_number" label="点击次数" align="center" />
    </el-table>
    <pagination-right
      v-if="!is_show"
      ref="paginationboxmer"
      :current-page="objnum.page"
      :page-sizes="[10]"
      :total="objtotal"
      @size-change="fetchPageSizerpoi($event)"
      @current-change="fetchCurrentPagerpoi"
    />
  </div>
</template>

<script>
import { officialAccountpageDataStatistics, officialAccountpageDataStatisticslist } from '@/api/reportExamine.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [
        {
          page_path: '/home',
          page_visit_pv: 1200,
          page_visit_uv: 800,
          page_staytime_pv: '00:01:35',
          entrypage_pv: 500,
          exitpage_pv: 300,
          page_share_pv: 50,
          page_share_uv: 40
        },
        {
          page_path: '/detail',
          page_visit_pv: 900,
          page_visit_uv: 600,
          page_staytime_pv: '00:02:10',
          entrypage_pv: 400,
          exitpage_pv: 350,
          page_share_pv: 30,
          page_share_uv: 25
        }
      ],
      dateRange: this.getYesterdayRange(),
      pickerOptions: {
        disabledDate(time) {
          // 禁止选择今天之后的日期
          return time.getTime() > Date.now()
        }
      },
      app_id: '',
      is_show: false,
      loading: false,
      newtablredata: [],
      objnum: {
        page: 1,
        pageSize: 10
      },
      objtotal: null,
      click_count: null
    }
  },
  created() {
    console.log(this.$route.query)
    this.app_id = this.$route.query.appid
    this.is_show = this.$route.query.is_show
    this.list()
    this.neawrlist()
  },
  mounted() {

  },
  methods: {
    getYesterdayRange() {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)

      const y = yesterday.getFullYear()
      const m = String(yesterday.getMonth() + 1).padStart(2, '0')
      const d = String(yesterday.getDate()).padStart(2, '0')
      const dateStr = `${y}-${m}-${d}`

      return [dateStr, dateStr] // 开始、结束都设为昨天
    },
    async list() {
      this.loading = true
      const params = {
        begin_date: this.dateRange?.[0] || '',
        end_date: this.dateRange?.[1] || ''
      }
      const data = await officialAccountpageDataStatistics({ ...params, app_id: this.app_id })
      this.tableData = data.data.list
      this.loading = false
      console.log('data', data)
    },
    onSearch() {
      this.list()
      this.objnum.page = 1
      this.neawrlist()
      // 这里发请求给后端
      // axios.get('/api/page-data', { params }).then(...)
    },
    onReset() {
      // this.dateRange = []
      this.list()
    },
    async neawrlist() {
      if (this.is_show) {
        return
      }
      const params = {
        begin_date: this.dateRange?.[0] || '',
        end_date: this.dateRange?.[1] || ''
      }
      const data = await officialAccountpageDataStatisticslist({ ...params, app_id: this.app_id, ...this.objnum })
      this.newtablredata = data.data.list
      this.objtotal = data.data.total
      this.click_count = data.data.click_count
      console.log('data', data)
    },
    // 分页
    fetchPageSizerpoi(e) {
      this.objnum.pageSize = e
      this.neawrlist()
    },
    fetchCurrentPagerpoi(e) {
      this.objnum.page = e
      this.neawrlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.wechat_boxr{
  padding: 30px;
}
.select_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.oneselect_box{
  margin-right: 10px;
}
</style>
